import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const WorldToursCategoryTypes = () => import('@/pages/world-tours/categoryTypes.vue');

export default [
  {
    path: '/world-tours/category-types',
    name: 'WorldToursCategoryTypes',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Классы',
      ],
    },
    component: WorldToursCategoryTypes,
  },
  {
    path: '/world-tours/category-types/:id',
    name: 'WorldToursCategoryTypesForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Классы',
      ],
    },
    component: WorldToursCategoryTypes,
  },
];
